<template>
    <div>
        <h1>Welcome to the Home Page!</h1>
        <!-- 其他首页内容 -->
        <img alt="Vue logo" src="../assets/logo.png">
        <HelloWorld msg="测试标题" />
        <RequestInfo />
    </div>
</template>

<script>
    import HelloWorld from '../components/HelloWorld.vue';
    import RequestInfo from '../components/RequestInfo.vue'

    export default {
        name: 'Home',
        components: {
            HelloWorld,
            RequestInfo
        }
    }
</script>